import { ThisConnector } from '../../../../api/connector'

export interface AttackEventTagsArgs {
  organizationUuid: string
}

export interface AttackEventTagsApiResponse {
  tags: string[]
}

export interface AttackEventTagsResponse {
  tags: string[]
}

export async function getAttackEventTags(
  this: ThisConnector,
  { organizationUuid }: AttackEventTagsArgs
): Promise<AttackEventTagsResponse> {
  const { tags } = await this.connector.get<AttackEventTagsApiResponse>(
    `/${organizationUuid}/tags/attack/events/list?expand=skip_links`
  )

  const response: AttackEventTagsResponse = {
    tags
  }

  return response
}
